module.exports = __webpack_public_path__ + "img/bg2.7df6bd51.jpg";